import { Component, h } from 'preact';

class TcrContentView extends Component
{
    constructor(props)
    {
        super(props);

        if (props.config && props.config.eventHandler)
        {
            props.config.eventHandler.scrollUp = this.scrollUp.bind(this);
        }
    }

    componentWillUpdate(nextProps, nextState)
    {
        if (nextProps.config && nextProps.config.eventHandler)
        {
            nextProps.config.eventHandler.scrollUp = this.scrollUp.bind(this);
        }
    }

    scrollUp()
    {
        this.ref.scrollTo(0, 0);
    }

    render()
    {
        if (!this.props.config || !this.props.config.visible) return;

        return (
            <div class="content" ref={dom => {this.ref = dom;}} data-expand_menu={this.props.showMenu} data-flex={this.props.config.flex}>
                {this.props.config.component}
            </div>
        );
    }
}

export { TcrContentView };